import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface OnboardingStepProps {
  children: ReactNode;
}

const stepVariants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 }
};

const transition = {
  type: "spring" as const,
  stiffness: 300,
  damping: 30
};

export function OnboardingStep({ children }: OnboardingStepProps) {
  return (
    <motion.div
      variants={stepVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
      className="w-full max-w-md mx-auto px-4 sm:px-6 flex flex-col items-center text-center gap-10 sm:gap-14"
    >
      {children}
    </motion.div>
  );
}

// Animation helper components
export function FadeUp({ children, delay = 0, className = '' }: { children: ReactNode; delay?: number; className?: string }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ScaleIn({ children, delay = 0, className = '' }: { children: ReactNode; delay?: number; className?: string }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
